<template>
  <div>
    <Banner />
    <div class="main-content">
      <div class="model-name">联系我们</div>
      <div class="model-name-en">Contact</div>
      <div class="base-info mt30" v-html="info.titleContent"></div>
      <!-- <div class="company-name mt30 mb8">广东友丰油茶科技有限公司</div>
      <div class="company-name-en mb24">Guangdong Youfeng Camellia Technology Co., Ltd.</div>
      <div class="base-info">
        <p>地址：韶关市浈江区犁市镇梅村铁路林场</p>
        <p>电话：400-931-3919</p>
        <p>邮箱：3367991505@qq.com</p>
        <p>邮政编码：512000</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import { 
  loadYxTitle
} from '@/api/api'
import Banner from '../../components/Banner'
export default {
  components: {
    Banner
  },
  data() {
    return {
      info: {

      }
    }
  },
  mounted() {
    loadYxTitle().then(res => {
      if(res.content) {
        var contact = res.content.find(item => {
          return item.titleType == 5
        })
        this.info = contact
      }
    })
  }
}
</script>

<style scoped lang="scss">
  .company-name {
    line-height: 30px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    text-align: center;
  }
  .company-name-en {
    line-height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
  .base-info {
    line-height: 30px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
  }
</style>